<template>
  <div class="wownow-launch" @click="launchClick" v-if="isShow">
    <slot />
    <wx-open-launch-app v-if="appid" class="launch-btn" :id="comId" :appid="appid" :extinfo="extinfoProps">
      <script type="text/wxtag-template">
        <style>
          .wechat-btn-to-wownowasdfasdfads {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            border: 0 none;
            background-color: transparent;
            border-color: transparent;
            outline: none;
          }
          .wechat-btn-to-wownowasdfasdfads:active, .wechat-btn-to-wownowasdfasdfads:hover, .wechat-btn-to-wownowasdfasdfads:link, .wechat-btn-to-wownowasdfasdfads:visited {
            width: 100%;
            border: 0 none;
            box-shadow: none;
            outline: none;
            border-color: transparent;
          }
        </style>
        <button class="wechat-btn-to-wownowasdfasdfads"></button>
      </script>
    </wx-open-launch-app>
  </div>
</template>
<script>
export default {
  props: {
    appid: {
      type: String,
      default: () => ''
    },
    clientWidth: {
      type: [Number, String],
      default: () => 0
    },
    clientHeight: {
      type: [Number, String],
      default: () => 0
    },
    extinfoProps: {
      type: String,
      default: () => ''
    },
    comId: {
      type: [Number, String],
      default: 'launch-btn'
    }
  },
  data() {
    return {
      wechatBtn: undefined,
      isShow: this.appid,
    };
  },
  mounted() {
    this.$nextTick(() => {
      new Promise((resolve, reject) => {
        // this.wechatBtn = document.getElementById('launch-btn');
        this.wechatBtn = document.getElementById(this.comId);
        this.wechatBtn && this.wechatBtn.addEventListener('launch', e => resolve(e));
        this.wechatBtn && this.wechatBtn.addEventListener('error', e => reject(e));
      }).then(res => this.$emit('launch-success')).catch(e => {
        console.log('launch-error: ', e);
        this.$emit('launch-error', e);
      }).finally(() => {
        console.log('launch-finally')
        this.timeout(() => {
          // this?.wechatBtn?.remove();
          // this.isShow = false;
        }, 10);
      });
    });
  },
  methods: {
    launchClick() {
      this.$emit('click');
    },
    timeout(fn, time = 0) {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        typeof fn === 'function' && fn();
      }, time);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .wownow-launch {
    position: relative;
    z-index: 3000;
  }
  .launch-btn, #launch-btn {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
</style>

<style lang="stylus">
  .launch-btn, #launch-btn {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .wechat-btn-to-wownowasdfasdfads {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0 none;
    background-color: transparent;
    border-color: transparent;
    z-index: 3000;
  }
  .wechat-btn-to-wownowasdfasdfads:active, .wechat-btn-to-wownowasdfasdfads:hover, .wechat-btn-to-wownowasdfasdfads:link, .wechat-btn-to-wownowasdfasdfads:visited {
    border: 0 none;
    box-shadow: none;
    border-color: transparent;
  }
</style>

